import type { FunctionComponent } from 'react';

import { Button, Group, Stack, Tooltip } from '@mantine/core';

import { useTranslation } from 'i18n';

const NS = 'menuManagementEditByBulk';

type BulkDockedButtonsProps = {
  hasBulkHistory: boolean;
  isButtonDisabled: boolean;
  isFormView: boolean;
  onBack: () => void;
  onRevert: () => void;
  onUndo: () => void;
};

export const BulkDockedButtons: FunctionComponent<BulkDockedButtonsProps> = ({
  hasBulkHistory,
  isButtonDisabled,
  isFormView,
  onBack,
  onRevert,
  onUndo,
}) => {
  const { t } = useTranslation(NS);

  if (isFormView) {
    return (
      <Stack gap="sm" w="100%">
        <Tooltip
          label={t('BulkDockedButtons.tooltipConfirmNextScreen')}
          position="top"
          disabled={isButtonDisabled}
        >
          <Button fullWidth disabled={isButtonDisabled} type="submit">
            {t('BulkDockedButtons.updateButton')}
          </Button>
        </Tooltip>
        {hasBulkHistory && (
          <Group justify="center">
            <Button variant="link" onClick={onUndo} h="auto" tt="none">
              {t('BulkDockedButtons.undoLastUpdateButton')}
            </Button>
            <Button variant="link" onClick={onRevert} h="auto" tt="none">
              {t('BulkDockedButtons.resetUpdatesButton')}
            </Button>
          </Group>
        )}
      </Stack>
    );
  }

  return (
    <Group w="100%" gap="xs">
      <Button style={{ flexGrow: 1 }} variant="outline" onClick={onBack}>
        {t('BulkDockedButtons.backButton')}
      </Button>
      <Button type="submit" style={{ flexGrow: 1 }}>
        {t('BulkDockedButtons.confirmButton')}
      </Button>
    </Group>
  );
};
